<template>
  <div class="d-flex"
       @mouseover="toggleHover(true)"
       @mouseleave="toggleHover(false)">
    <div class="w-100 truncate">
      {{ rawValue }}
    </div>
    <div v-if="hover"
         class="flex-shrink-1 pl-2">
      <ActionItemGroup>
        <a :href="cockpitLink"
           :title="tr('javascript.TX_TO_COCKPIT')">
          <Icon :title="tr('javascript.TX_TO_COCKPIT')"
                class="hover-links"
                name="circle-right4"></Icon>
        </a>
        <a v-if="hasEvaluationAccess()"
           :href="evaluationLink"
           :title="tr('javascript.TX_GOTO_EVALUATION')">
          <Icon :title="tr('javascript.TX_GOTO_EVALUATION')"
                class="hover-links"
                name="stats-dots"></Icon>
        </a>
        <a v-if="hasSystemRights()"
           class="clickable administration-control admin-system-id"
           :title="tr('javascript.TX_TO_SYSTEM_CONFIG')"
           :system-id="systemId">
          <Icon :title="tr('javascript.TX_TO_SYSTEM_CONFIG')"
                class="hover-links"
                name="wrench"></Icon>
        </a>
      </ActionItemGroup>
    </div>
  </div>
</template>

<script>
  import { translator } from '~/zf/frontend/common/mixins';
  import VcomProvider from '../../../VcomProvider';
  import Icon from '../../../common/layout/Icon.vue';
  import ActionItemGroup from '../../../common/layout/ActionItemGroup.vue';

  export default {
    name: 'System',
    compatConfig: {
      MODE: 3,
    },
    components: {
      Icon,
      ActionItemGroup,
    },
    mixins: [translator],
    data() {
      return {
        rawValue: null,
        hover: false,
        systemId: null,
      };
    },
    computed: {
      cockpitLink() {
        return `${VcomProvider.baseUrl}/default/cockpit/index/systemId/${this.systemId}`;
      },
      evaluationLink() {
        return `${VcomProvider.baseUrl}/evaluation/index/index/systemId/${this.systemId}`;
      },
    },
    mounted() {
      if (this.params.value === null || this.params.value === undefined) {
        return;
      }
      this.rawValue = this.params.value;
      this.systemId = this.params.data.DT_RowId;
    },
    methods: {
      toggleHover(state) {
        this.hover = state;
      },
      hasSystemRights() {
        return VcomProvider.hasSystemConfigRights;
      },
      hasEvaluationAccess() {
        return VcomProvider.hasEvaluationAccess;
      },
    },
  };
</script>
